<template>
  <div 
    class="account__section autorefresh"
  >
    <div>
      <h3
        class="account__section__title"
        style="display: flex; flex-direction: column;"
      >
        Data Saver
      </h3>
      <p class="account__section__desc">Turn on to save data bundles</p>
    </div>
    <div
      :class="{
        'inactive': settings.autorefresh.status
      }"
      class="input-group__checkbox autorefresh__checkbox"
      @click="$store.commit('settings/toggleAutorefresh')"
    >
      <input
        v-model="settings.autorefresh.status"
        class="input-group__checkbox__input"
        type="checkbox"
      />
      <label
        class="input-group__checkbox__label"
        :class="{
          'input-group__checkbox__label--active': !settings.autorefresh.status
        }"
      >
      </label>
      <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg" v-show="!settings.autorefresh.status">
        <path d="M12 1.42L10.59 0L4 6.59L1.42 4.02L0 5.43L4 9.42L12 1.42Z"></path>
      </svg> 
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    settings() {
      return this.$store.getters["settings/settings"];
    }
  }
};
</script>

<style lang="scss">
.autorefresh {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  .input-group {
    &__checkbox {
      width: 48px;
      height: 20px;
      background: var(--green);
      &__label{
        width: 14px;
        height: 14px;
        top: 3px;
        left: 3px;  
        &--active{
          left: 30px;
          background: var(--always-white);
        }
      }
      svg{
        fill: var(--always-white);
        position: relative;
        top:2px;
        left:4px;
      }
      &.inactive{
        background: var(--gray);
      }
    }
  }
}
.account__section.autorefresh{
  margin-bottom: 20px;
  text-align: left;
  &:last-child{
    margin-bottom: 0px;
  }
}
</style>
